// Slick Carousel
import Glide from "@glidejs/glide";

class ProjectShowcaseFeaturedPicture {
  constructor() {
    // Wait until DOM is ready. Then, store the carousel element in a variable.
    document.addEventListener("DOMContentLoaded", () => {
      this.carousel = document.querySelector(".project-showcase-featured");
      this.init();
    });
  }

  init() {
    // Store the carousel element in a variable.
    const carousel = this.carousel;

    // Check if the carousel element exists.
    console.log(carousel);

    if (carousel) {
      // Add arrows
      carousel.insertAdjacentHTML(
          "beforeend",
          `<div class="glide__arrows" data-glide-el="controls">
                <button class="glide__arrow glide__arrow--left" data-glide-dir="<"><i class="fa-solid fa-chevron-left"></i></button>
                <button class="glide__arrow glide__arrow--right" data-glide-dir=">"><i class="fa-solid fa-chevron-right"></i></button>
            </div>`
      );

      // Mount carousel
      var projectShowcaseFeaturedPictureCarousel = new Glide(
          ".project-showcase-featured",
          {
            type: "carousel",
            perView: 1,
            autoplay: 3000,
          }
      ).mount();
    }
  }
}

export default ProjectShowcaseFeaturedPicture;
